var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowCircleRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0007 25.6693C20.444 25.6693 25.6673 20.4459 25.6673 14.0026C25.6673 7.55928 20.444 2.33594 14.0007 2.33594C7.55733 2.33594 2.33398 7.55928 2.33398 14.0026C2.33398 20.4459 7.55733 25.6693 14.0007 25.6693Z",
    fill: "#4E277B",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5303 18.9916C12.3086 18.9916 12.087 18.9099 11.912 18.7349C11.5736 18.3966 11.5736 17.8366 11.912 17.4982L15.412 13.9982L11.912 10.4982C11.5736 10.1599 11.5736 9.5999 11.912 9.26156C12.2503 8.92323 12.8103 8.92323 13.1486 9.26156L17.267 13.3799C17.6053 13.7182 17.6053 14.2782 17.267 14.6166L13.1486 18.7349C12.9736 18.9099 12.752 18.9916 12.5303 18.9916Z",
    fill: "#4E277B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCircleRight);
export default __webpack_public_path__ + "static/media/arrow-circle-right.f14223114ba9efdb079a47894dc7cf26.svg";
export { ForwardRef as ReactComponent };